// Shared heart-counter sync: keeps navbar heart badge and home heart card in sync.
export const HEART_SYNC_EVENT = 'gs-heart-sync';

export function broadcastHearts(count) {
  if (typeof count !== 'number' || Number.isNaN(count)) return;
  window.dispatchEvent(new CustomEvent(HEART_SYNC_EVENT, { detail: { hearts: count } }));
}

export function onHeartsChange(callback) {
  const handler = (e) => {
    if (e?.detail && typeof e.detail.hearts === 'number') callback(e.detail.hearts);
  };
  window.addEventListener(HEART_SYNC_EVENT, handler);
  return () => window.removeEventListener(HEART_SYNC_EVENT, handler);
}
